<script>
import {importSimYearFeeAPI, getImportProcessApi} from './api'
import SelectChannel from "@/components/dict/select-channel.vue";

export default {
  name: 'ImportExcel',
  components: {SelectChannel},
  data() {
    return {
      dialogVisible: false,
      agent_id: '',
      api_data_type: '',
      task_id: '',
      importFile: null,
      timer: null,

      percentage: 0,
      error_list: [],
    }
  },
  methods: {
    open(api_data_type) {
      this.api_data_type = api_data_type
      this.dialogVisible = true
    },

    handleClose() {
      this.api_data_type = ''
      this.agent_id = ''
      this.importFile = null
      this.dialogVisible = false
      this.percentage = 0
      this.error_list = []

      if (this.timer) {
        clearInterval(this.timer);
      }
    },
    beforeUpload(file) {
      if (file.name.split('.').pop() !== 'xlsx' && file.name.split('.').pop() !== 'xls') {
        this.$message.error('请上传xlsx或xls格式文件!')
        return false
      }
    },

    getImportTaskProcess() {
      getImportProcessApi(this.task_id).then(res => {
        this.percentage = res.percentage
        this.error_list = res.error_list || []

        if (this.percentage === 100) {
          clearInterval(this.timer);
        }
      })
    },

    importTable(file) {
      this.importFile = file.file
    },
    submit() {
      if (!this.importFile || !(this.importFile instanceof File)) {
        this.$message.error('请选择文件!')
        return;
      }
      if (!this.agent_id) {
        this.$message.error('请选择渠道!')
        return;
      }
      const fd = new FormData()
      fd.append('import_file', this.importFile)
      fd.append('agent_id', this.agent_id)
      if (this.api_data_type === 'sim_year_fee') {
        importSimYearFeeAPI(fd).then(res => {
          this.task_id = res.task_id
          this.timer = setInterval(this.getImportTaskProcess, 1000);
        })
      }
    }
  }
}
</script>

<template>
  <el-dialog
      title="导入EXCEL"
      :visible.sync="dialogVisible"
      width="50%"
      :before-close="handleClose">
    <el-form>
      <el-form-item label="渠道：">
        <select-channel v-model="agent_id"></select-channel>
      </el-form-item>
      <el-form-item label="导入excel：">
        <el-upload
            class="upload-demo"
            action=" "
            :before-upload="beforeUpload"
            :http-request="importTable"
            :show-file-list="false"
            accept=".xls,.xlsx"
        >
          <el-tooltip class="item" effect="dark" placement="top-start" popper-class="custom-tooltip">
            <div slot="content">
              <ul>
                <li>1、因为服务器资源有限，上传的文件必须控制在1000条以内；</li>
                <li>2、插入规则
                  <ul>
                    <li>a、数据已存在，则系统对该行数据不会做任何操作</li>
                    <li>b、数据不存在，则新增插入</li>
                    <li>c、数据校验失败，则不会插入，请修改后重新导入【只需要上传失败的行】</li>
                  </ul>
                </li>
              </ul>
            </div>
            <el-button
                style="margin-bottom: 10px;margin-right: 10px;"
                icon="el-icon-upload"
                type="primary"
                size="mini"
                plain
            >导入
            </el-button>
          </el-tooltip>
        </el-upload>
        <span v-if="importFile">文件名称：{{ importFile ? importFile.name : '' }}</span>
      </el-form-item>
    </el-form>

    <el-progress v-if="task_id" :percentage="percentage"></el-progress>
    <el-table :data="error_list" v-if="error_list.length > 0" style="margin-top: 20px;">
      <el-table-column prop="row_index" label="错误行"></el-table-column>
      <el-table-column prop="error_msg" label="错误信息"></el-table-column>
    </el-table>

    <span slot="footer" class="dialog-footer">
      <el-button @click="handleClose">取 消</el-button>
      <el-button type="primary" @click="submit" v-if="! this.task_id">上传</el-button>
    </span>
  </el-dialog>
</template>

<style scoped lang="scss">
.custom-tooltip {
  max-width: 100px; // 根据需要调整宽度
  white-space: pre-line; // 保留换行符
  ul {
    padding-left: 0;
    list-style-type: none;
    li {
      line-height: 150%;
      ul {
        padding-left: 10px;
      }
    }
  }
}

</style>